export default class Utilities {
    static replaceBrackets(template, ...args) {
        return template.replace(/{([0-9])}/g, (match, index) =>
            args[index] != null ? args[index] : match
        );
    }
}


// WEBPACK FOOTER //
// ./src/Utilities/Utilities.js